<template>
  <div id="v3GrabRebateRoot">
    <div>
      <div id="v3GrabTopDiv" style="position:relative;height: 80px;width: 100%;align-items: Center;">
        <img id="v3GrabTopBg" src="~assets/img/SdkV3/GrabRebateLogBg.png"
          style="position:absolute;height: 100%;width: 100%;">
        <div
          style="position:absolute;top:0%;width: 100%;height:45px;display: flex;flex-direction: row;justify-content: center;align-items: center;color: white;">
          {{ rebateName }}主播红包
          <img src="~assets/img/SdkV3/ArrowLeftWhite.png" style="position:absolute;left:5px;height: 30px;"
            @click="hideGrabRebatePage" />
        </div>
      </div>
    </div>
    <div style="width:100%;display: flex;align-items: center;justify-content: center;height: 25px;color:#4B4646;font-size: x-small;">{{
      surplus == '1' ? "恭喜你，抢到了红包！" : "所有红包已经被抢光了" }}</div>
    <div id="v3GrabRebateContents"
      style="width: 96%;height:calc(70vh - 80px - 25px);overflow-y: auto;margin-left: 2%;margin-right: 2%;background-color: white;">
      <div v-for="(item, index) in listData" :key=" index + item.datetime"
        :index="index + ''" style="position:relative;width:96%;height:45px;color:black;display:flex;align-items:center;margin-left:2%;margin-right:2%;flex-direction: row;margin-top: 5px;">
        <div style="display:flex;justify-content:center;align-items:center;width:40px;height: :100%;">
          <img src="~assets/img/SdkV3/GrabRebateIcon.png" style="object-fit: scale-down;width: 40px;height: 42px;" />
        </div>
        <div style="display:flex;flex-direction: column;justify-content:center;width:calc(70% - 40px);height: :100%;margin-left:2px;">
          <span style="color:#4B4646;font-size: xx-small;font-weight: bold;">{{ item.username }}</span>
          <span style="color:#4B4646;font-size: xx-small;margin-top: 2px;">{{ item.datetime }}</span>
        </div>
        <div style="display:flex;flex-direction: column;justify-content:center;align-items:center;width:56px;height: :100%;position:absolute;right:10px;font-size: x-small;">
          <span :style="{color:item.self == '1' || item.best == '1' ? 'red':'#4B4646', fontWeight: 'bold'}">{{ item.amount }}元</span>
          <img v-if="item.best == '1'" src="~assets/img/SdkV3/BestLuck.png" style="object-fit: scale-down;width: 100%;height: 12px;margin-top: 2px;" />
          <div v-else-if="item.self == '1'" style="font-size: x-small;font-weight: bold;width: 100%;height: 12px;margin-top: 2px;color: red;display: flex;justify-content: center;align-items: center;" >本人</div>
        </div>
      </div>
      <HR style="border:1 dashed #987cb9;" width="96%" color=#E4E4E4 SIZE=0.5></HR>
    </div>

  </div>
</template>

<script>

import { request } from '@/SdkV3/network/request';
import getRequestParams from "@/signParams";

export default {
  props: {
    surplus: "", // 是否还有红包剩余未抢（0：否，1：是）
    listData: [],
    rebateName: "",
  },
  data() {
    return {
      // surplus: "0", // 是否还有红包剩余未抢（0：否，1：是）
      // listData: [],
    }
  },
  components: {

  },
  // watch: {
  //   grabRebateItem: {
  //     handler(newValue, oldValue) {
  //       console.log("watch");
  //       if (newValue != null) {
  //         console.log("newValue != null");
  //         this.fetchGrabRebateLog();// 获取抢红包列表数据
  //       }
  //     }
  //   },
  // },
  created() {

  },
  methods: {
    fetchGrabRebateLog() {
      let storeCommomParams = this.$store.state.commonParameters;
      storeCommomParams['confid'] = this.grabRebateItem['confid']
      console.log("获取抢红包列表数据,", storeCommomParams);
      console.log("this.grabRebateItem :", this.grabRebateItem);
      let rebateReqParams = getRequestParams({}, storeCommomParams);
      request({
        url: this.urls.REBATE_GRABLOG,
        params: {
          data: rebateReqParams
        },
      }).then(res => {
        this.surplus = res.surplus
        this.listData = JSON.parse(res.grabRebateLog);
        console.log("抢红包列表数据", this.listData);

      });
    },
    hideGrabRebatePage() {
      this.$parent.hideGrabRebatePage()
    }
  },
  computed: {
    // 计算属性要传参的话，就是用函数返回
    // 红包子项倒计时处理
    // getTimeCountdown(){
    //   return rebateItem =>{
    //   }
    // }
  }
}
</script>

<style>
#v3GrabRebateRoot {
  position: relative;
  height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #F6F6F6;
  /* align-items: center; */

}
#v3GrabRebateContents::-webkit-scrollbar {
  	display: none;
}
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/rebate/V3GrabRebateLog.vue